import { render, staticRenderFns } from "./EditInstallationQuestionTemplate.vue?vue&type=template&id=58b85e39&"
import script from "./EditInstallationQuestionTemplate.vue?vue&type=script&lang=js&"
export * from "./EditInstallationQuestionTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports